export default class Counter {
    constructor(quill, options) {
        this.quill = quill;
        this.options = options;
        this.counterContainer = document.querySelector(options.counterContainer);
        quill.on('text-change', this.update.bind(this));
        this.update();
    }

    update() {
        this.counterContainer.innerHTML = `${this.quill.getText().length - 1} / ${this.options.maxChar}`;
    }
}
